/** Photography generated from the standing brief in docs/IMAGE-SYSTEM.md. */
export const contactHeroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/c97c7511-dd18-4747-a05d-b6b87d1649a5.jpg',
  alt: 'An open blank notebook and face-down phone on a pale oak desk in soft morning light',
}

export const contactSidebarImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/04cfd5f6-8e03-4dd5-a0a3-8ade4fc521f0.jpg',
  alt: 'A minimal calendar page and matte black pen arranged on textured off-white paper',
}

export const contactStepImages: { image: string; alt: string }[] = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/fc3cb34b-3750-445e-a2da-6fd61c4effe6.jpg',
    alt: 'A folded bone-paper card beside a black dot and muted blue-grey edge',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/02894af5-5089-4f9c-a0a8-fe92441e1575.jpg',
    alt: 'Two bone-coloured circles connected by a thin black line with one muted sage accent',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd71d6b8-79bb-46ac-a649-5393e7f5fbd6.jpg',
    alt: 'Three aligned bone-paper sheets held by a black binder clip with a muted clay edge',
  },
]
